import { useCart } from '@/hooks/useCart';

export default function CartDrawer() {
  const { items, isOpen, setIsOpen, removeItem, updateQuantity, totalPrice, clearCart } = useCart();

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 z-[60] bg-black/40 transition-opacity duration-300 ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsOpen(false)}
      />

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 z-[70] h-full w-full max-w-md bg-background-50 shadow-2xl transition-transform duration-300 flex flex-col ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-background-200/60">
          <h3 className="font-heading text-lg font-bold text-foreground-950">
            Solicitud de Cotización
          </h3>
          <button
            onClick={() => setIsOpen(false)}
            className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="Cerrar carrito"
          >
            <i className="ri-close-line text-xl text-foreground-600" />
          </button>
        </div>

        {/* Items */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {items.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 mb-4">
                <i className="ri-shopping-cart-line text-2xl text-foreground-300" />
              </div>
              <p className="text-foreground-500 text-sm font-medium mb-1">Su carrito está vacío</p>
              <p className="text-foreground-400 text-xs">Agregue productos para solicitar una cotización</p>
            </div>
          ) : (
            <div className="space-y-4">
              {items.map((item) => (
                <div
                  key={item.id}
                  className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/60"
                >
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-20 h-20 rounded-md object-cover flex-shrink-0"
                  />
                  <div className="flex-1 min-w-0">
                    <h4 className="font-heading text-sm font-semibold text-foreground-950 truncate">
                      {item.name}
                    </h4>
                    <p className="text-foreground-400 text-xs mt-0.5">{item.volume}</p>
                    <p className="text-primary-600 font-heading text-sm font-bold mt-1">
                      ${item.price.toLocaleString()} <span className="text-foreground-400 text-xs font-normal">USD</span>
                    </p>

                    {/* Quantity controls */}
                    <div className="flex items-center gap-3 mt-2">
                      <div className="flex items-center gap-1 bg-background-100 rounded-md overflow-hidden">
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity - 1)}
                          className="w-8 h-8 flex items-center justify-center text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
                          aria-label="Disminuir cantidad"
                        >
                          <i className="ri-subtract-line text-xs" />
                        </button>
                        <span className="w-10 text-center text-sm font-semibold text-foreground-800">
                          {item.quantity}
                        </span>
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                          className="w-8 h-8 flex items-center justify-center text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
                          aria-label="Aumentar cantidad"
                        >
                          <i className="ri-add-line text-xs" />
                        </button>
                      </div>
                      <button
                        onClick={() => removeItem(item.id)}
                        className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-400 hover:text-red-500 hover:bg-red-50 transition-colors cursor-pointer"
                        aria-label="Eliminar producto"
                      >
                        <i className="ri-delete-bin-line text-sm" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="border-t border-background-200/60 px-6 py-5 space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-foreground-600 text-sm font-medium">Total estimado</span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                ${totalPrice.toLocaleString()} <span className="text-foreground-400 text-sm font-normal">USD</span>
              </span>
            </div>
            <p className="text-foreground-400 text-xs">
              Los precios son referenciales. El total final dependerá de volumen, frecuencia de compra y condiciones de entrega.
            </p>
            <a
              href="/contacto"
              onClick={(e) => {
                e.preventDefault();
                setIsOpen(false);
                window.location.href = '/contacto';
              }}
              className="flex items-center justify-center gap-2 w-full px-6 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Solicitar Cotización
              <i className="ri-arrow-right-line" />
            </a>
            <button
              onClick={clearCart}
              className="flex items-center justify-center gap-2 w-full px-6 py-2.5 rounded-full border border-background-200 text-foreground-500 text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-delete-bin-line text-xs" />
              Vaciar carrito
            </button>
          </div>
        )}
      </div>
    </>
  );
}